import Vue from "vue";
import Router from "vue-router";

import LoginPage from "@/spa/pages/LoginPage";
import ProfilePage from "@/spa/pages/ProfilePage";

import DashboardPage from "@/spa/pages/DashboardPage";

import WinePage from "@/spa/pages/contents/wine/WinePage";
import DetailsPage from "@/spa/pages/contents/wine/WineDetailPage";
import LimitsPage from "@/spa/pages/contents/wine/LimitsPage";
import AromaPage from "@/spa/pages/contents/AromaPage";
import RegionPage from "@/spa/pages/contents/RegionPage";
import GrapePage from "@/spa/pages/contents/GrapePage";
import WineryPage from "@/spa/pages/contents/WineryPage";
import CurationPage from "@/spa/pages/contents/CurationPage";

import ServicePage from "@/spa/pages/operation/ServicePage";
import AddressPage from "@/spa/pages/operation/store/AddressPage";
import NoticePage from "@/spa/pages/operation/NoticePage";
import HolidayPage from "@/spa/pages/operation/HolidayPage";
import WarehousePage from "@/spa/pages/operation/store/WarehousePage";

import SignupManagementPage from "@/spa/pages/operation/SignupManagementPage";
import UserManagementPage from "@/spa/pages/operation/UserManagementPage";
import SupplierManagementPage from "@/spa/pages/operation/SupplierManagementPage";

import WpUserManagementPage from "@/spa/pages/operation/WpUserManagementPage";
import CartsManagementPage from "@/spa/pages/operation/CartsManagementPage ";

import NotFound from "@/spa/pages/NotFound";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Login",
      component: LoginPage
    },
    {
      path: "/profile",
      name: "Profile",
      component: ProfilePage
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: DashboardPage
    },
    {
      path: "/wine",
      name: "Wine",
      component: WinePage
    },
    {
      path: "/details",
      name: "Details",
      component: DetailsPage
    },
    {
      path: "/limits",
      name: "Limits",
      component: LimitsPage
    },
    {
      path: "/aroma",
      name: "Aroma",
      component: AromaPage
    },
    {
      path: "/region",
      name: "Region",
      component: RegionPage
    },
    {
      path: "/grape",
      name: "Grape",
      component: GrapePage
    },
    {
      path: "/winery",
      name: "Winery",
      component: WineryPage
    },
    {
      path: "/curation",
      name: "Curation",
      component: CurationPage
    },
    {
      path: "/setting",
      name: "Setting",
      component: ServicePage
    },
    {
      path: "/address",
      name: "Address",
      component: AddressPage
    },
    {
      path: "/notice",
      name: "Notice",
      component: NoticePage
    },
    {
      path: "/holiday",
      name: "Holiday",
      component: HolidayPage
    },
    {
      path: "/warehouse",
      name: "Warehouse",
      component: WarehousePage
    },
    {
      path: "/signup",
      name: "signup",
      component: SignupManagementPage
    },
    {
      path: "/users",
      name: "users",
      component: UserManagementPage
    },
    {
      path: "/supplier",
      name: "supplier",
      component: SupplierManagementPage
    },
    {
      path: "/wp-users",
      name: "wp-users",
      component: WpUserManagementPage
    },
    {
      path: "/carts",
      name: "carts",
      component: CartsManagementPage
    },
    {
      path: "*",
      component: NotFound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/configs/router.js